// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__V7U0C","approved":"Status_approved__2wI5v","rejected":"Status_rejected__3dkOy","expired":"Status_expired__207np","label":"Status_label__1kwEv"};